import type { PaymentStatus } from './types';

const STATUS_STYLES: Record<PaymentStatus, string> = {
  INITIATED: 'bg-muted text-muted-foreground',
  REQUIRES_ACTION: 'bg-amber-100 text-amber-700',
  PENDING: 'bg-blue-100 text-blue-700',
  SUCCESS: 'bg-green-100 text-green-700',
  FAILED: 'bg-red-100 text-red-700',
  EXPIRED: 'bg-muted text-muted-foreground',
  REFUNDED: 'bg-orange-100 text-orange-700',
  DISPUTED: 'bg-purple-100 text-purple-700',
};

export function PaymentStatusBadge({ status }: { status: PaymentStatus }) {
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${STATUS_STYLES[status] ?? 'bg-muted text-muted-foreground'}`}>
      {status.replace('_', ' ')}
    </span>
  );
}
